import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { PropTypes } from "components/controls";

export interface LabelProps {
    color?: PropTypes.Color;
    label: string;
}


class Label extends React.PureComponent<LabelProps & WithStyles<typeof styles>>{

    render() {
        const { color, classes, label } = this.props;
        const rootClass = classNames([
            { [classes.root]: true },
            { [classes.colorPrimary]: color === 'primary' },
            { [classes.colorSecondary]: color === 'secondary' },
            { [classes.colorSuccess]: color === 'success' },

            { [classes.colorInfo]: color === 'info' },
            { [classes.colorWarning]: color === 'warning' },
            { [classes.colorDanger]: color === 'danger' },

        ]);
        return <span className={rootClass}>{label}</span>;
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        display: 'inline',
        padding: '.2em .6em .3em',
        fontSize: '75%',
        fontWeight: 'bold',
        lineHeight: 1,
        color: '#fff',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'baseline',
        borderRadius: '.25em',
    },
    colorPrimary: {
        backgroundColor: '#337ab7',
    },
    colorSecondary: {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
    },
    colorSuccess: {
        backgroundColor: '#5cb85c',
    },
    colorInfo: {
        backgroundColor: '#5bc0de',
    },
    colorWarning: {
        backgroundColor: '#f0ad4e',
    },

    colorDanger: {
        backgroundColor: '#d9534f',
    }
});

export default withStyles(styles)(Label);